import { ERRORS } from '../../../index';

const { Component } = Shopware;
const {object} = Shopware.Utils;

Component.extend('ecocode-trustpilot-email-config', 'sw-email-field-deprecated', {
    props: {
        value: {
            type: String,
            default() {
                return '';
            }
        }
    },
    emits: ['update:value'],
    computed: {
        inputFieldEl() {
            try {
                return document.getElementById(this.formFieldName);
            } catch (e) {
                console.info('unable to get input field element')
            }
        },
    },
    data() {
        return {
            currentValue: this.value
        };
    },
    methods: {
        validateEmail(email) {
            const isValid = this.validationService.email(email);
            this.inputFieldEl.style.color = isValid ? 'inherit' : ERRORS.INVALID_VALUE_COLOR_CODE;
        },
        onInput(event) {
            this.validateEmail(event.target.value);
        },
        onChange(event) {
            const isValid = this.validationService.email(event.target.value);
            this.currentValue = isValid ? event.target.value : '';
            this.$emit('update:value', object.cloneDeep(this.currentValue));
        }
    },
    mounted() {
        this.validateEmail(this.value);
    }
});
